import type { ITwoFactorLocale } from '@/Pages/Onboard/TwoFactor/Locale/TwoFactor.locale';

const enUS: ITwoFactorLocale = {
  title: 'Two-factor authentication',
  subtitle: {
    configuring: 'Setting up your 2FA…',
    error: 'Could not start the setup.',
    scan: "Scan the QR code below with your authenticator app (Google Authenticator, Authy, etc.). Point your app's camera at this code:",
  },
  generatingQRCode: 'Generating QR code…',
  qrAlt: '2FA QR code',
  cannotScan: "Can't scan?",
  useCodeBelow: 'Use the code below:',
  secret: {
    label: 'Setup code',
    placeholder: '-',
    copyHint: 'Copy and paste this code directly into your authenticator app',
    copied: 'Copied!',
  },
  verification: {
    label: 'Verification code',
    placeholder: '_ _ _ _ _ _',
    hint: 'Enter the 6-digit code generated in your app. It refreshes every 30 seconds.',
  },
  button: {
    verify: 'Verify',
    verifyAndEnter: 'Verify and sign in',
  },
  success: {
    title: '2FA enabled successfully!',
    subtitle: 'Your account now requires an authenticator app code at login.',
  },
  errors: {
    initSessionExpired: 'Setup session expired. Please log in again.',
    finishSessionExpired: 'Session expired. Please log in again.',
    tooManyAttempts: 'Too many attempts. Try again in a few seconds.',
    configRequired: 'Setup required. Reload the login.',
    initGeneric: 'Error initializing 2FA',
    invalidCode: 'Invalid code. Check and try again.',
    initFirst: 'Start the setup again.',
    finishGeneric: 'Error finishing 2FA',
    sessionMissing: 'Setup session missing. Please log in again.',
  },
};
export { enUS };
